<template>
  <b-modal class="modal-lg" id="deleteNavLink" title='Delete Navigation Link' :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" ok-only @hide="hideModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><i class="os-icon os-icon-file text-light"></i> Delete Navigation Link</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default">
      <div class="row">
        <div class="col-12" v-if="$props.navLinkName">
          You are about to delete <b>{{ $props.navLinkName }}</b>
        </div>
      </div>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel }">
      <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary" type="button" @click="cancel()">
        <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>Cancel
      </button>
      <button aria-label="Delete Link" data-dismiss="modal" class="btn btn-primary" type="button" :disabled="!$props.navLinkId || navLinkId == 0" @click="deleteNavLink()">
        <fontAwesomeIcon :icon="['fa', 'thumbs-up']" class="text-light mr-2"/>Delete Link
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'DeleteLinkConfrimationModal',
  props: ['navLinkId', 'navLinkName'],
  methods: {
    hideModal() {
      this.$parent.disableOverlay()
    },
    deleteNavLink() {
      self = this
      if(this.$props.navLinkId && this.$props.navLinkId > 0) {
        this.$store.dispatch('menuBuilderStore/deleteLink', this.$props.navLinkId).then(() => {
          self.hideModal()
          self.$parent.getNavigation()
          self.$root.$emit('bv::hide::modal', 'deleteNavLink')
        })
      }
    }
  }
}
</script>

<style scoped>
.clickable-link {
  cursor: pointer;
  color: #047bf8;
}

.clickable-link:hover {
  font-weight: 600;
  text-decoration: underline;
}
</style>